module.exports = __webpack_public_path__ + "img/context_selector_arrow.36e82906.svg";